// extracted by mini-css-extract-plugin
export default {"tagButtonFrame":"Header_tagButtonFrame__E6LUc","button":"Header_button__eWBz9","buttonActive":"Header_buttonActive__Czvhv"};